import { Helmet } from "react-helmet-async";

const SITE_URL = "https://sixtyfinance.com";

export const SEO = ({
  title,
  description,
  path = "/",
  image,
  keywords,
}) => {
  const fullTitle = title
    ? `${title} | Sixty Finance`
    : "Sixty Finance | Australia-wide Finance & Mortgage Brokers";
  const desc =
    description ||
    "Sixty Finance is an Australia-wide finance broker helping Australians secure home loans, car & asset finance, personal loans and business lending. Call 0431 550 780.";
  const url = `${SITE_URL}${path}`;
  const ogImage =
    image ||
    "https://customer-assets.emergentagent.com/job_trust-local-biz-2/artifacts/7be7sfe8_Screenshot%202026-07-12%20at%2011.39.16%E2%80%AFam.png";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Sixty Finance" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="en_AU" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />

      <meta name="robots" content="index,follow,max-image-preview:large" />
    </Helmet>
  );
};
